import { Request } from '../requests/Request';
import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';

export class DeleteCustomizedViewsRequest extends Request<IMultipleIdsParams, IResult> {
  constructor(ids: string[]) {
    super('deleteCustomizedViews', { ids: ids });
  }
}
